import '../../OrganizationModals.scss';
import { Modal } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { useRemoveStudents } from 'queryHooks/Organization/Students/useRemoveStudents';
import Paragraph from 'components/TextComps/Paragraph';

type Props = {
  isOpen: boolean;
  studentIds: string[];
  close: () => void;
};

export const DeleteStudents = ({ isOpen, studentIds, close }: Props) => {
  const { t } = useTranslation();
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  const deleteStudents = useRemoveStudents(selectedOrganizationId, { onSuccess: () => close() });

  const confirm = () => {
    deleteStudents.mutate(studentIds);
  };

  return (
    <Modal
      open={isOpen}
      onClose={close}
      className='organization-modal'
      title={t('DeleteStudents', { ns: 'studentsPage' })}
      titleIcon={<TrashIcon />}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => close(),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => confirm(),
      }}
    >
      <div className='modal-body'>
        <Paragraph>
          <>{t('AreYouSureYouWantToDeleteStudents', { ns: 'studentsPage' })}</>
        </Paragraph>
      </div>
    </Modal>
  );
};
